// extracted by mini-css-extract-plugin
export var big_icon = "big-icon-module--big_icon--3a7c7";
export var bound = "big-icon-module--bound--57216";
export var icon = "big-icon-module--icon--1f5b7";
export var svg = "big-icon-module--svg--420cd";
export var text = "big-icon-module--text--08408";